var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "about-yy" }, [
    _c("div", { staticClass: "company-profile padding-main mobile-padding" }, [
      _c("div", { staticClass: "profile-title-en" }, [
        _vm._v("Company profile"),
      ]),
      _c("div", { staticClass: "profile-title" }, [
        _vm._v(_vm._s(_vm.$t("aboutYY.companyProfile"))),
      ]),
      _c("div", { staticClass: "company" }, [
        _vm._v(_vm._s(_vm.$t("common.yyName"))),
      ]),
      _c("div", { staticClass: "hidden-sm-and-down" }, [
        _c("div", { staticClass: "profile-content" }, [
          _vm._v(_vm._s(_vm.$t("aboutYY.companyProfileTip"))),
        ]),
      ]),
      _c("div", { staticClass: "hidden-md-and-up" }, [
        _c("div", { staticClass: "profile-content" }, [
          _vm._v(_vm._s(_vm.$t("aboutYY.companyProfileTip3"))),
        ]),
        _c("div", { staticClass: "profile-content" }, [
          _vm._v(_vm._s(_vm.$t("aboutYY.companyProfileTip4"))),
        ]),
        _c("div", { staticClass: "profile-content" }, [
          _vm._v(_vm._s(_vm.$t("aboutYY.companyProfileTip5"))),
        ]),
        _c("div", { staticClass: "profile-content" }, [
          _vm._v(_vm._s(_vm.$t("aboutYY.companyProfileTip6"))),
        ]),
        _c("div", { staticClass: "profile-content" }, [
          _vm._v(_vm._s(_vm.$t("aboutYY.companyProfileTip7"))),
        ]),
        _c("div", { staticClass: "profile-content" }, [
          _vm._v(_vm._s(_vm.$t("aboutYY.companyProfileTip8"))),
        ]),
        _c("div", { staticClass: "profile-content" }, [
          _vm._v(_vm._s(_vm.$t("aboutYY.companyProfileTip9"))),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "our-team padding-main mobile-padding" }, [
      _c("div", { staticClass: "team-title" }, [
        _vm._v(_vm._s(_vm.$t("aboutYY.ourTeam"))),
      ]),
      _c(
        "div",
        { staticClass: "team-content" },
        [
          _c("el-image", { attrs: { src: "/img/team_01.png", fit: "cover" } }),
          _c("el-image", { attrs: { src: "/img/team_02.png", fit: "cover" } }),
          _vm._m(0),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "enterprise-culture mobile-padding" }, [
      _c("div", { staticClass: "culture-title" }, [
        _vm._v(_vm._s(_vm.$t("aboutYY.enterpriseCulture"))),
      ]),
      _c("div", {
        staticClass: "culture-content",
        domProps: { innerHTML: _vm._s(_vm.$t("aboutYY.enterpriseCultureTip")) },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right hidden-sm-and-down" }, [
      _c("span", [_vm._v("Our team")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }